<template>

  <!-- 物流包装 -->
  <div class="Minister-top information">
    <div class="Minister-top-top Ministerbackground">
      <div class="Minister-top-left Minister-top-color">物流包装</div>
    </div>
    <div class="information_content" style="padding-top: 12px">
      <span style="margin-left: 40px;font-size: 20px;">销售</span>
      <el-divider></el-divider>
      <div class="information_input" style="margin-bottom:20px;" >
        <div class="information_Title">
          <span class="tips">*</span>
          发票
        </div>
        <div class="addre_check">
          <el-select slot="append"
                     class="item_check_addre"
                     v-model="formData.invoice"
                     :disabled="isChakan || system < 5"
                     placeholder="请选择"
                     filterable
          >
            <el-option v-for="item in invoices"
              :key="item.value"
              :label="item.name"
              :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div class="information_input" style="margin-bottom:20px;" >
        <div class="information_Title">
          税率
        </div>
        <div class="addre_check">
          <el-select slot="append"
            class="item_check_addre"
            v-model="formData.taxRateTheme"
            :disabled="isChakan || system < 5"
            placeholder="税率主题"
            filterable
          >
          <el-option v-for="item in taxRateTheme"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
          </el-select>
          <el-select slot="append"
            class="item_check_addre"
            v-model="formData.taxExemption"
            :disabled="isChakan || system < 5"
            placeholder="税率豁免"
            filterable
          >
          <el-option v-for="item in taxExemption"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="el-table-width">
          <el-table
          :data="invoiceList"
          :disabled="isChakan || system < 5"
          style="margin-top: 10px"
          border>
            <el-table-column
              label="国家"
              prop="countryCode"
              align="center"
            ></el-table-column>
            <el-table-column
              label="税率"
              prop="values"
              align="center">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.value"
                  filterable 
                  @change="handleChange($event,scope)"
                >
                  <el-option
                    v-for="item in scope.row.values"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span style="margin-left: 40px;font-size: 20px;">物流</span>
      <el-divider></el-divider>
      <div class="information_input" style="margin-bottom:20px;" >
        <div class="information_Title">
          <span class="tips">*</span>
          发货地点
        </div>
        <div class="addre_check">
          <el-select slot="append"
                     class="item_check_addre"
                     v-model="formData.countryCode"
                     :disabled="isChakan || system < 5"
                     placeholder="请选择"
                     filterable
          >
            <el-option label="中国(CN)"  value="cn"></el-option>
          </el-select>
          <el-input
              :disabled="isChakan || system < 5"
              class="item_check_addre" v-model="formData.province"></el-input>
          <el-input
              :disabled="isChakan || system < 5"
              class="item_check_addre" v-model="formData.city"></el-input>
          <el-input
              :disabled="isChakan || system < 5"
              class="item_check_addre" v-model="formData.postCode"></el-input>
        </div>
      </div>
      <div class="information_input" style="margin-bottom:20px;" >
        <div class="information_Title">
          <span class="tips">*</span>
          处理时间
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-select
                v-model="formData.chuliTime"
                class="width67 "
                :disabled="system < 5 || isChakan"
                filterable
                clear
            >
              <el-option label="PT0S for immediately(出单立即发货)"  value="PT0S for immediately"></el-option>
              <el-option label="PT24H(一天)"  value="PT24H"></el-option>
              <el-option label="P2D(两天)"  value="P2D"></el-option>
              <el-option label="P3D(3天)"  value="P3D"></el-option>
              <el-option label="P4D(4天)"  value="P4D"></el-option>
              <el-option label="P5D(5天)"  value="P5D"></el-option>
              <el-option label="P7D(7天)"  value="P7D"></el-option>
              <el-option label="P10D(10天)"  value="P10D"></el-option>
              <el-option label="P14D(14天)"  value="P14D"></el-option>
              <el-option label="P21D(21天)"  value="P21D"></el-option>
              <el-option label="P30D(30天)"  value="P30D"></el-option>
              <el-option label="P60D(60天)"  value="P60D"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom:20px;" >
        <div class="information_Title">
          <span class="tips">*</span>
          运输价格表
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-select
                v-model="formData.jiagebiao"
                class="width67 "
                :disabled="system < 5 || isChakan"
                filterable
                clear
                @change="changeJiageBiao"
            >
              <el-option v-for="(item,index) in jiageOptions"
                         :key="index"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-button
                v-if="system == 5 && !isChakan"
                style="margin-left: 10px"
                type="primary"
                @click="updateJiage">
              更新价格表
            </el-button>
          </div>
        </div>
      </div>
      <span style="margin-left: 40px;font-size: 20px;">售后</span>
      <el-divider></el-divider>
      <div class="information_input" style="margin-bottom:20px;" >
        <div class="information_Title">
          退货条件
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-select
                v-model="formData.tuihuo"
                class="width67 "
                :disabled="system < 5 || isChakan"
                filterable
                clear
                @change="changeTuihuo"
            >
              <el-option v-for="(item,index) in tuihuoOptions"
                         :key="index"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom:20px;" >
        <div class="information_Title">
          保修政策
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-select
                v-model="formData.baoxiu"
                class="width67 "
                :disabled="system < 5 || isChakan"
                @change="changeBaoxiu"
                filterable
                clear
            >
              <el-option v-for="(item,index) in baoxiuOptions"
                         :key="index"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {ajaxPost, Baseurl} from "../../../api/api/api";
export default {
  name: 'wuliuComp',
  props: {
    score: {
      type: Array,
      default() {
        return [0,0,0,0];
      },
    },
    system: {
      type: Number,
      default:5,
    },
    isEdit: {
      type: Boolean,
      default:false,
    },
    isChakan: {
      type: Boolean,
      default:false,
    }
  },
  data() {
    return {
      //卖家id
      sellerId:'',
      // 类目分类
      categoryId:null,
      // 分类税率数组
      invoiceList:[],
      invoiceLists:[],
      // 发票数组
      invoices:[{
        name: 'VAT (增值税)',
        value:'VAT'
      },{
        name: 'VAT_MARGIN (增值税保证金)',
        value:'VAT_MARGIN'
      },{
        name: 'WITHOUT_VAT (不包含增值税)',
        value:'WITHOUT_VAT'
      },{
        name: 'NO_INVOICE (无发票)',
        value:'NO_INVOICE'
      }],
      // 税率主题数组
      taxRateTheme: [],
      // 税率豁免数组
      taxExemption:[],
      formData:{
        countryCode:'CN',
        province:'guangdong',
        city:'shenzhen',
        postCode:'518101',
        chuliTime:'',
        jiagebiao:'',
        jiageName:'',
        tuihuo:'',
        tuihuoName:'',
        baoxiu:'',
        baoxiuName:'',
        // 发票类型
        invoice:'NO_INVOICE',
        // 税率主题
        taxRateTheme:'',
        // 税率豁免
        taxExemption:''
      },
      jiageOptions:[],
      tuihuoOptions:[],
      baoxiuOptions:[],
      // 国家税率数组
      rates:[]
    }
  },
  methods: {
    handleChange(r,e){
      if (this.rates.length == 0) {
        this.rates.push({
          rate: r,
          countryCode: e.row.countryCode
        })
      } else {
        for (let index = 0; index < this.rates.length; index++) {
          if (e.row.countryCode == this.rates[index].countryCode) {
            this.rates[index].rate = r
            return
          }
        }
        this.rates.push({
          rate: r,
          countryCode: e.row.countryCode
        })
      }
    },
    initData(){
      this.jiageOptions = []
      this.tuihuoOptions = []
      this.baoxiuOptions = []
    },
    // 选择类目分类后设置categoryId值
    setCategoryId(val,editRates){
      this.categoryId = val
      ajaxPost(Baseurl + 'allegroCategory/getTaxSettings', {
        sellerId: this.sellerId,
        categoryId: this.categoryId
      }).then((res) => {
        const { code, data } = res.data
        if (code == 200) {
          this.invoiceList = data.rates
          for (let index = 0; index < this.invoiceList.length; index++) {
            for (let j = 0; j < this.invoiceList.length; j++) {
              if (editRates[j] != undefined || editRates !=undefined) {
                if(editRates[j].label == this.invoiceList[index].countryCode){
                  this.invoiceList[index].value = editRates[j].value
                }
              }
            }
          }
          this.taxExemption = data.exemptions
          this.taxRateTheme = data.subjects
        }
      })
    },
    //选择店铺后设置 sellerid值
    setSellerId(val){
      this.sellerId = val
      //获取价格
      ajaxPost(Baseurl + 'allegroDelivery/getShippingRates', {
        sellerId: this.sellerId
      }).then((res) => {
        const { code, data } = res.data
        if (code == 200) {
          this.jiageOptions = data
        }
      })
      //获取退货
      ajaxPost(Baseurl + 'allegroAfterSaleServices/getReturnPolicies', {
        sellerId: this.sellerId
      }).then((res) => {
        const { code, data } = res.data
        if (code == 200) {
          this.tuihuoOptions = data
        }
      })

      //获取保修
      ajaxPost(Baseurl + 'allegroAfterSaleServices/getUserWarranties', {
        sellerId: this.sellerId
      }).then((res) => {
        const { code, data } = res.data
        if (code == 200) {
          this.baoxiuOptions = data
        }
      })
    },
    updateJiage(){
      if (this.sellerId){
        //获取价格
        ajaxPost(Baseurl + 'allegroDelivery/getShippingRates', {
          sellerId: this.sellerId
        }).then((res) => {
          const { code, data } = res.data
          if (code == 200) {
            if (data.length > 0){
              this.jiageOptions = data
            } else {
              this.$message.warning('需要先在allegro后台配置价格表信息!')
            }
          }
        })
      } else {
        this.$message.warning('请先选择店铺,再更新价格表信息!')
      }
    },
    changeJiageBiao(val){
      this.formData.jiageName = this.jiageOptions.filter(item =>{
        return item.id == val
      })[0].name
    },
    changeTuihuo(val){
      this.formData.tuihuoName = this.tuihuoOptions.filter(item =>{
        return item.id == val
      })[0].name
    },
    changeBaoxiu(val){
      this.formData.baoxiuName = this.baoxiuOptions.filter(item =>{
        return item.id == val
      })[0].name
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../ozon.less";
.addre_check{
  width: 88%;
  display: flex;
  .item_check_addre{
    width: 20%;
    margin-right: 12px;
  }
}
.el-table-width{
  width: 36%;
  display: flex;
}
</style>
